import gql from "graphql-tag";
import {useCallback} from "react";

import {useMutation} from "@khan/data-gql";
import {gqlOp} from "@khan/data-gql-core";
import {Errors, KAError} from "@khan/logging";

import type {
    freeForTeachersReferralMutation,
    freeForTeachersReferralMutationVariables,
} from "./__graphql-types__/freeForTeachersReferralMutation.ts";

export const FREE_FOR_TEACHERS_REFERRAL_MUTATION = gqlOp<
    freeForTeachersReferralMutation,
    freeForTeachersReferralMutationVariables
>(gql`
    mutation freeForTeachersReferralMutation($referralCode: String!) {
        trackUserReferralRedemption(referralCode: $referralCode) {
            error {
                code
                debugMessage
            }
        }
    }
`);

export const useMakeFreeForTeachersReferral = (): ((
    variables: freeForTeachersReferralMutationVariables,
) => Promise<void>) => {
    const [mutate] = useMutation(FREE_FOR_TEACHERS_REFERRAL_MUTATION);

    const makeFreeForTeachersReferral = useCallback(
        async (variables: freeForTeachersReferralMutationVariables) => {
            const result = await mutate(variables);
            let error: any = null;
            if (result.status === "error") {
                error = result.error;
            } else if (
                result.status === "success" &&
                result.data.trackUserReferralRedemption.error
            ) {
                error =
                    result.data.trackUserReferralRedemption.error.debugMessage;
            }

            if (error) {
                throw new KAError(
                    "Failed to record Free for Teachers referral",
                    Errors.Internal,
                    {cause: error},
                );
            }
        },
        [mutate],
    );

    return makeFreeForTeachersReferral;
};
